import { useNavigate } from "react-router-dom"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { PremiumPlan } from "types/premium.types"
import { extractStaticPart } from "utils/navigatorUtils"
import PAGES from "constants/pages"
import { useAppSelector } from "appRedux/hooks"
import { usePlansQuery } from "appRedux/slices/premiumApiSlice"
import PremiumLogo from "components/atoms/_icons/PremiumLogo"
import PremiumPlanCard from "components/molecules/PremiumPlan"

export default function PremiumPlansTemplate() {
  const plans = useAppSelector(state => state.premium.plans)

  usePlansQuery()

  const navigate = useNavigate()

  function handleOnPlanClicked(plan: PremiumPlan) {
    const path = extractStaticPart(PAGES.checkout.path)
    navigate(path + plan.id)
  }

  return (
    <Container>
      <PremiumLogo/>
      <PlansContainer>
        {plans ? plans.map(plan => (<PremiumPlanCard
          key={plan.id}
          {...plan}
          onClick={() => handleOnPlanClicked(plan)}
        />)) : null}
      </PlansContainer>
    </Container>
  )
}

const Container = styled(Stack)(() => ({
  alignItems: "center",
  height: "100%",
  flexGrow: 1,

  "& svg": {
    width: "212px",
    height: "212px"
  }
}))

const PlansContainer = styled("div")(() => ({
  width: "100%",
  height: "100%",
  marginTop: "48px"
}))
